export default function isBusinessEditable(businessSession) {
	const access = businessSession?.access;
	return access === 'owner' || access === 'admin';
}
